import { PageTypeSuffix } from '@/constants'
import { useNotification, useStore } from '@/containers'
import { getTranslate } from '@/utils/api-interceptors'
import { Disclosure } from '@headlessui/react'
import Link from 'next/link'
import { v4 as uuidv4 } from 'uuid'

const Footer = () => {
  const { bottomMenu } = useStore()
  const { systemConfig } = useNotification()

  return (
    <footer id='footer' className='mx-auto mt-4 w-full'>
      <section className={`bg-white pt-4`}>
        <div className='container mb-5'>
          <div className='grid grid-cols-2 items-center'>
            <div className='text-base font-semibold uppercase text-dark-900'>
              KẾT NỐI DIENMAYKHO
            </div>

            <ul className='flex items-center justify-end gap-2'>
              {systemConfig?.warehouseFacebook && (
                <li className=''>
                  <Link
                    href={systemConfig?.warehouseFacebook || '/'}
                    target='blank'
                    className='flex h-[20px] w-[20px] items-center justify-center rounded-full bg-primary-base'
                  >
                    <img
                      src='/assets/icons/social/facebook.svg'
                      alt='Facebook'
                      className='h-[20px] w-[20px]'
                    />
                  </Link>
                </li>
              )}
              {systemConfig?.warehouseYoutube && (
                <li className=''>
                  <Link
                    href={systemConfig?.warehouseYoutube || '/'}
                    target='blank'
                    className='flex h-[20px] w-[20px] items-center justify-center rounded-full bg-primary-base'
                  >
                    <img
                      src='/assets/icons/social/youtube.svg'
                      alt='Youtube'
                      className='h-[20px] w-[20px]'
                    />
                  </Link>
                </li>
              )}
              {systemConfig?.warehouseInstagram && (
                <li className=''>
                  <Link
                    href={systemConfig?.warehouseInstagram || '/'}
                    className='flex h-[20px] w-[20px] items-center justify-center rounded-full bg-primary-base'
                    target='blank'
                  >
                    <img
                      src='/assets/icons/social/instagram.svg'
                      alt='Instagram'
                      className='h-[20px] w-[20px]'
                    />
                  </Link>
                </li>
              )}
              {systemConfig?.warehouseTikTok && (
                <li className=''>
                  <Link
                    href={systemConfig?.warehouseTikTok || '/'}
                    target='blank'
                    className='flex h-[20px] w-[20px] items-center justify-center rounded-full bg-primary-base'
                  >
                    <img
                      src='/assets/icons/social/tiktok.svg'
                      alt='Tiktok'
                      className='h-[20px] w-[20px]'
                    />
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div
          className={`container mx-auto mb-5 flex items-end justify-between`}
        >
          <div className='w-full leading-snug text-dark-900'>
            <p className='mb-2 block text-sm'>Tổng đài mua hàng:</p>
            <div className='hotLine mb-2 flex flex-wrap items-center gap-3'>
              {systemConfig?.warehousePhone && (
                <div className='w-full'>
                  <p className='text-base font-bold'>
                    {systemConfig?.warehousePhone}
                  </p>
                  <p className='text-xs italic'>
                    {systemConfig?.warehouseLabelPhone}
                  </p>
                </div>
              )}
            </div>
            <p className='mb-2 block text-sm'>Địa chỉ kho hàng:</p>
            <ul className='flex flex-wrap gap-2 text-sm text-dark-900'>
              <li className='flex items-center gap-2'>
                <span className='flex h-5 w-5 items-center justify-center rounded-full bg-black-400 font-semibold text-white'>
                  1
                </span>
                <span className='italic'>Lê Trọng Tấn, Thanh Xuân, Hà Nội</span>
              </li>
              <li className='flex items-center gap-2'>
                <span className='flex h-5 w-5 items-center justify-center rounded-full bg-black-400 font-semibold text-white'>
                  2
                </span>
                <span className='italic'>
                  Ngõ 908 Kim Giang, Thanh Liệt, Thanh Trì, Hà Nội
                </span>
              </li>
              <li className='flex items-center gap-2'>
                <span className='flex h-5 w-5 items-center justify-center rounded-full bg-black-400 font-semibold text-white'>
                  3
                </span>
                <span className='italic'>
                  Quốc Lộ 32, Phường Phúc Diễn, Bắc Từ Liêm, Hà Nội
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className={`mt-3 flex flex-wrap justify-start`}>
          {bottomMenu &&
            bottomMenu.length > 0 &&
            bottomMenu.map((e, i) => (
              <Disclosure as={'div'} className={`w-full`} key={i}>
                {({ open }) => (
                  <>
                    <Disclosure.Button className='relative h-12 w-full border-t border-white-500 px-3 text-left text-sm font-semibold text-dark-400'>
                      {getTranslate(e.name)}
                      <svg
                        className={`${
                          open ? 'rotate-180' : 'rotate-[-90deg]'
                        } absolute right-3 top-4 h-4 w-4`}
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='#000000'
                        aria-hidden='true'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d={open ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'}
                        />
                      </svg>
                    </Disclosure.Button>

                    <Disclosure.Panel>
                      {e.children && e.children.length > 0 && (
                        <ul>
                          {e.children.map(f => (
                            <li
                              key={uuidv4()}
                              className='flex h-10 items-center border-t border-white-500 pl-5 text-sm '
                            >
                              {f.type === 'link' ? (
                                <a
                                  href={`${f.url}` || ''}
                                  className='block w-full'
                                >
                                  {getTranslate(f.name)}
                                </a>
                              ) : (
                                <a
                                  href={
                                    `/${f.slug + PageTypeSuffix.PAGE_CMS}` || ''
                                  }
                                >
                                  {getTranslate(f.name)}
                                </a>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
        </div>
      </section>

      <section className={`footerInfo bg-white pb-32`}>
        <span
          className={`container flex flex-wrap justify-center border-t border-white-500 pt-4 text-xs font-semibold`}
        >
          © 2025 DIENMAYKHO. All rights reserved
        </span>
      </section>
    </footer>
  )
}

export { Footer }
